import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import Farmermasterlist from "../Farmermaster/Farmermasterlist";
import Farmermasterdata from "../Farmermaster/Farmermasterdata";

function FarmerMasterTab() {
  return (
    <Tabs
      defaultActiveKey="farmermasterlist"
      id="uncontrolled-tab-example"
      className="mb-3"
    >
      <Tab eventKey="farmermasterlist" title="จดทะเบียนหัวหน้ากลุ่มชาวไร่อ้อย">
        <Farmermasterlist />
      </Tab>
      <Tab eventKey="farmermasterdata" title="ข้อมูลหัวหน้ากลุ่มชาวไร่อ้อย">
        <Farmermasterdata />
      </Tab>
    </Tabs>
  );
}

export default FarmerMasterTab;
